import FacetedFiltering from '../components/FacetedFiltering';

export default class StaticSearch {
  constructor(section) {
    this.el = section.el;
    this.facetedFilters = null;

    if (this.el.querySelector('[data-faceted-filter]')) {
      this.facetedFilters = new FacetedFiltering(this.el);
    }
  }

  onSectionUnload() {
    if (this.facetedFilters) {
      this.facetedFilters.unload();
    }
  }
}
